import { render, staticRenderFns } from "./PorTipoVetoMensagemVeto.vue?vue&type=template&id=76eba0a8&scoped=true"
import script from "./PorTipoVetoMensagemVeto.vue?vue&type=script&lang=js"
export * from "./PorTipoVetoMensagemVeto.vue?vue&type=script&lang=js"
import style0 from "./PorTipoVetoMensagemVeto.vue?vue&type=style&index=0&id=76eba0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eba0a8",
  null
  
)

export default component.exports